import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CampManagementApiService {

    constructor(private http: ApiHttpClient) { }


    public saveInfo(request: camps.CampBasicInfoSaveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`camp/basicinfo`, request, true);
    }

    public saveVisibility(request: camps.CampVisiblitySaveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`camp/visibility`, request, true);
    }

    public saveCreditPointsUsage(request: camps.CampCreditPointsUsageSaveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`camp/creditPointsUsage`, request, true);
    }
}
